var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-header'),_c('pd-header'),(_vm.$route.meta.showLeftPanel)?_c('left-panel'):_vm._e(),_c('v-main',{staticClass:"bg"},[_c('router-view',{key:_vm.$route.path})],1),_c('app-footer'),_c('pd-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }